// GTM initialization and SPA page view tracking
export function initGTM(containerId) {
  if (!containerId || window.__gtmInitialized) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  const gtm = document.createElement('script');
  gtm.async = true;
  gtm.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
  document.head.appendChild(gtm);
  window.__gtmInitialized = true;
}

function pushPageView() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_path: window.location.pathname + window.location.search,
    page_title: document.title,
  });
}

export function trackSpaPageViews() {
  let lastPath = window.location.pathname + window.location.search;

  const onChange = () => {
    const now = window.location.pathname + window.location.search;
    if (now !== lastPath) {
      lastPath = now;
      pushPageView();
    }
  };

  const wrap = (fn) =>
    function () {
      const result = fn.apply(this, arguments);
      onChange();
      return result;
    };

  if (window.history.pushState) window.history.pushState = wrap(window.history.pushState);
  if (window.history.replaceState) window.history.replaceState = wrap(window.history.replaceState);
  window.addEventListener('popstate', onChange);

  // initial page view
  pushPageView();
}


